<template>
  <path
    d="M20 2.00018H4C2.9 2.00018 2 2.90018 2 4.00018V22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00018C22 2.90018 21.1 2.00018 20 2.00018ZM19 13.0002L16.5 11.5002L14 13.0002V5.00018H19V13.0002Z"
  />
</template>
